<template>
  <div>
    <!-- Filtros encabezado -->
    <transition name="fade-bottom">
      <section>
        <!-- Encabezado con botones de acciones -->
        <b-row>
          <b-col
            cols="12"
            class="text-right"
          >

            <!-- Recargar -->
            <b-button
              variant="outline-secondary"
              class="mr-1"
              :disabled="isLoading"
              @click="clearFilters"
            >
              <feather-icon
                icon="RefreshCwIcon"
                class="mr-50"
                :class="{ 'rotate-icon': isLoading }"
              />
              Recargar
            </b-button>

            <!-- Filtrar -->
            <b-button
              variant="outline-primary"
              @click="showFilterModal = true"
            >
              <feather-icon
                icon="FilterIcon"
                class="mr-50"
              />
              Filtrar
            </b-button>

          </b-col>
        </b-row>
      </section>
    </transition>
    <!-- Modulos -->
    <b-row>
      <b-col
        v-if="refreshKey != 0"
        cols="12"
        class="mt-2"
      >
        <aportaciones
          :key="refreshKey"
          :is-lista="true"
          :plan="inPlan"
          :fecha-inicio="filters.fechaInicio"
          :fecha-fin="filters.fechaFin"
          @loading="handleLoading"
        />
      </b-col>
    </b-row>
    <!-- Modal de filtros -->
    <b-modal
      v-model="showFilterModal"
      title="Filtrar transacciones"
      size="md"
      no-close-on-backdrop
      centered
    >
      <!-- Tipo de búsqueda -->
      <div class="mb-3">
        <div class="filter-title">
          ¿Cómo deseas realizar la búsqueda?
        </div>

        <div class="row">

          <!-- PLAN -->
          <div class="col-6">
            <div
              class="filter-option"
              :class="{ active: filterType === 'plan' }"
              @click="selectFilterType('plan')"
            >
              <div class="filter-option-radio">
                <b-form-radio
                  v-model="filterType"
                  value="plan"
                  name="filter-type"
                />
              </div>

              <div class="filter-option-icon">
                <feather-icon
                  icon="BookOpenIcon"
                  size="24"
                />
              </div>

              <div class="filter-option-title">
                Plan de estudios
              </div>

              <div class="filter-option-description">
                Buscar por un plan específico
              </div>
            </div>
          </div>

          <!-- FECHA -->
          <div class="col-6">
            <div
              class="filter-option"
              :class="{ active: filterType === 'fecha' }"
              @click="selectFilterType('fecha')"
            >
              <div class="filter-option-radio">
                <b-form-radio
                  v-model="filterType"
                  value="fecha"
                  name="filter-type"
                />
              </div>

              <div class="filter-option-icon">
                <feather-icon
                  icon="CalendarIcon"
                  size="24"
                />
              </div>

              <div class="filter-option-title">
                Fecha de timbrado
              </div>

              <div class="filter-option-description">
                Buscar por un rango de fechas
              </div>
            </div>
          </div>

        </div>
      </div>

      <hr>

      <!-- BODY: PLAN -->
      <div v-if="filterType === 'plan'">

        <b-form-group
          label="Plan de estudios"
          label-for="filter-plan"
        >
          <plan-select
            id="filter-plan"
            :plan-id.sync="inPlan"
          />
        </b-form-group>

      </div>

      <!-- BODY: FECHAS -->
      <div v-else>
        <div class="row">
          <div class="col-6">
            <b-form-group label="Fecha de inicio">
              <b-form-datepicker
                v-model="filters.fechaInicio"
                placeholder="Seleccionar"
                locale="es-MX"
                :max="filters.fechaFin || null"
              />
            </b-form-group>
          </div>

          <div class="col-6">
            <b-form-group label="Fecha de fin">
              <b-form-datepicker
                v-model="filters.fechaFin"
                placeholder="Seleccionar"
                locale="es-MX"
                :min="filters.fechaInicio || null"
              />
            </b-form-group>
          </div>
        </div>
      </div>

      <template #modal-footer>

        <b-button
          variant="outline-secondary"
          @click="clearFilters"
        >
          Limpiar
        </b-button>

        <b-button
          variant="primary"
          :disabled="!hasValidFilter"
          @click="applyFilters"
        >
          Buscar
        </b-button>

      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BFormGroup,
  BFormDatepicker,
  BRow,
  BCol,
  BFormRadio,
  // BFormCheckbox,
} from 'bootstrap-vue'
import { ref, computed, reactive } from '@vue/composition-api'
import PlanSelect from '@core/components/selects/PlaneSelect.vue'
// import PeriodoSelect from '@core/components/selects/PeriodoSelect.vue'
// import AspirantesList from '../servicio-escolar/components/aspirantes/AspirantesList.vue'
// import Solicitudes from '../components/compras/compras-list/SolicitudesSE.vue'
// import PagaresList from '../components/compras/compras-list/PagaresList.vue'
import Aportaciones from '../components/compras/compras-list/TransList.vue'
// import FacturasList from './ParaEmitirList.vue'
// import Grupos from '../aci/grupos/Grupos.vue'

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    // Solicitudes,
    // PagaresList,
    Aportaciones,
    // AspirantesList,
    // FacturasList,
    PlanSelect,
    BFormRadio,
    // Grupos,
    // PeriodoSelect,
    // BFormCheckbox,
  },
  setup() {
    const inPlan = ref(null)
    const nivelPlan = ref(null)
    const showFilterModal = ref(false)
    const refreshKey = ref(1)
    const filterType = ref('plan')
    const filters = reactive({
      fechaInicio: null,
      fechaFin: null,
    })

    const isLoading = ref(false)

    const handleLoading = value => {
      isLoading.value = value
    }
    /**
     * Indica si existe algún filtro de fecha.
     */
    const hasDates = computed(() => !!filters.fechaInicio || !!filters.fechaFin)

    const hasValidFilter = computed(() => {
      if (filterType.value === 'plan') {
        return !!inPlan.value
      }

      return (
        !!filters.fechaInicio
    && !!filters.fechaFin
      )
    })

    const selectFilterType = type => {
      filterType.value = type

      if (type === 'plan') {
        filters.fechaInicio = null
        filters.fechaFin = null
      }

      if (type === 'fecha') {
        inPlan.value = null
      }
    }

    const clearFilters = () => {
      showFilterModal.value = false
      filters.fechaInicio = null
      filters.fechaFin = null
      inPlan.value = null
      nivelPlan.value = null
      refreshKey.value += 1
    }

    const applyFilters = () => {
      if (!hasValidFilter.value) {
        return
      }
      showFilterModal.value = false
      refreshKey.value += 1
    }

    return {
      inPlan,
      nivelPlan,
      showFilterModal,
      filters,
      filterType,
      clearFilters,
      applyFilters,
      selectFilterType,
      handleLoading,
      isLoading,
      hasDates,
      hasValidFilter,
      refreshKey,
    }
  },
}
</script>
<style scoped>
.filter-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #5e5873;
}

.filter-option {
  position: relative;
  min-height: 135px;
  padding: 16px;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.filter-option:hover {
  border-color: #7367f0;
  transform: translateY(-1px);
}

.filter-option.active {
  border: 2px solid #7367f0;
  background: #f8f7ff;
}

.filter-option-radio {
  position: absolute;
  top: 10px;
  right: 10px;
}

.filter-option-icon {
  margin-top: 8px;
  margin-bottom: 10px;
  color: #7367f0;
}

.filter-option-title {
  font-size: 14px;
  font-weight: 600;
  color: #5e5873;
}

.filter-option-description {
  font-size: 12px;
  color: #6e6b7b;
  margin-top: 4px;
}
</style>
